import React, { Component } from 'react';
import { MappingRoles } from '../../../helpers/constants';
import ErrorMsgBlockComponent from '../../Error/ErrorMessageBlock';
import actions from 'redux-form/lib/actions';
import { checkEmployeeIDLength } from '../../../helpers/GlobalFunctions';
import { RolePrivileges } from "../../../shared/RolePrivileges"
class CreateMappedUser extends Component {
    constructor(props) {
        super(props);
        this.myFormRef = React.createRef();
    }

    /**
     * @description Function to disable edit mode while restting the form
     * @memberof CreateMappedUser
     */
    cancelEdit = () => {
        this.myFormRef.reset();
        this.props.handleCancel();
    }

    render() {
        const { loading, userObj, handleInputChange, handleBlur, onEnterPress, showSuccessMsg, formErrors, saveUser, userSaveError } = this.props;
        
        return (
            <>
                {loading ? <div className="loading-overlay-upload add-mapped-user-overlay"><span>{actions.load}</span></div> : ''}
                <div className="customer-fields surgeon-details" data-testid="addUser">
                    <div className="add-user-container">
                        <div className="card-body py-0">
                            <form onSubmit={onEnterPress} noValidate ref={(el) => this.myFormRef = el}>
                                <div className="row">
                                    {showSuccessMsg ?
                                        <div className="col-sm-12">
                                            <div className="customer-save-success-msg">
                                                <p>{showSuccessMsg}</p>
                                            </div>
                                        </div>
                                        : ''}
                                    {userSaveError ?
                                        <div className="col-sm-12">
                                            <div className="customer-save-error-msg">
                                                <ErrorMsgBlockComponent className="pb-4 m-0" errorObject={userSaveError} />
                                            </div>
                                        </div>
                                        : ''}
                                </div>
                                <fieldset className="customer-fields reset-password p-0">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group row">
                                                <label htmlFor="firstName" className="col-sm-4 col-form-label shrink-label">First Name<span className="red">*</span></label>
                                                <div className="col-sm-8">
                                                    <input
                                                        type="text"
                                                        id="firstName"
                                                        data-testid="firstName"
                                                        autoComplete="off"
                                                        maxLength={50}
                                                        className={`form-control ${formErrors && formErrors.firstName ? 'has-error' : ''}`}
                                                        value={userObj && userObj.firstName ? userObj.firstName : ''}
                                                        onChange={(e) => handleInputChange('firstName', e.target.value)}
                                                    />
                                                    {formErrors && formErrors.firstName ?
                                                        <div className="customer-error-msg">
                                                            <p>{formErrors.firstName}</p>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group row">
                                                <label htmlFor="lastName" className="col-sm-4 col-form-label shrink-label">Last Name<span className="red">*</span></label>
                                                <div className="col-sm-8">
                                                    <input
                                                        type="text"
                                                        id="lastName"
                                                        data-testid="lastName"
                                                        autoComplete="off"
                                                        maxLength={50}
                                                        className={`form-control ${formErrors && formErrors.lastName ? 'has-error' : ''}`}
                                                        value={userObj && userObj.lastName ? userObj.lastName : ''}
                                                        onChange={(e) => handleInputChange('lastName', e.target.value)}
                                                    />
                                                    {formErrors && formErrors.lastName ?
                                                        <div className="customer-error-msg">
                                                            <p>{formErrors.lastName}</p>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group row">
                                                <label htmlFor="email" className="col-sm-4 col-form-label shrink-label">Email<span className="red">*</span></label>
                                                <div className="col-sm-8">
                                                    <input
                                                        type="text"
                                                        id="email"
                                                        data-testid="email"
                                                        autoComplete="off"
                                                        className={`form-control ${formErrors && formErrors.email ? 'has-error' : ''}`}
                                                        value={userObj && userObj.email ? userObj.email : ''}
                                                        onChange={e => handleInputChange('email', e.target.value)}
                                                        onBlur={(e) => handleBlur('email', e.target.value)}
                                                    />
                                                    {formErrors && formErrors.email ?
                                                        <div className="customer-error-msg">
                                                            <p>{formErrors.email}</p>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group row">
                                                <label htmlFor="role" className="col-sm-4 d-flex align-items-center col-form-label shrink-label">
                                                  <RolePrivileges />
                                                    Role<span className="red">*</span>
                                                </label>
                                                <div className="col-sm-8">
                                                    <select
                                                        id="role"
                                                        data-testid="role"
                                                        defaultValue={userObj && userObj.role ? userObj.role : ''}
                                                        className={`form-select ${formErrors && formErrors.role ? 'has-error' : ''}`}
                                                        onChange={(e) => handleInputChange('role', e.target.value)}>
                                                        <option value="">Select a role</option>
                                                        {MappingRoles.filter(x => !x.hideFromAddUser).map(role =>
                                                            <option key={`option-${role.userRole}`} value={role.userRole}>{role.specialLabel}</option>
                                                        )}
                                                    </select>
                                                    {formErrors && formErrors.role ?
                                                        <div className="customer-error-msg">
                                                            <p>{formErrors.role}</p>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group row">
                                                <label htmlFor="employeeID" className="col-sm-4 col-form-label shrink-label">Employee ID</label>
                                                <div className="col-sm-8">
                                                    <input
                                                        type="number"
                                                        id="employeeID"
                                                        data-testid="employeeID"
                                                        pattern="[0,9]{0,8}"
                                                        autoComplete="off"
                                                        min={0}
                                                        max={99999999}
                                                        maxLength={8}
                                                        className={`form-control ${formErrors && formErrors.employeeID ? 'has-error' : ''}`}
                                                        value={userObj && userObj.employeeID ? userObj.employeeID : ''}
                                                        onKeyDown={checkEmployeeIDLength}
                                                        onChange={(e) => handleInputChange('employeeID', e.target.value)}
                                                    />
                                                    {formErrors && formErrors.employeeID ?
                                                        <div className="customer-error-msg">
                                                            <p>{formErrors.employeeID}</p>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <div className="row">
                                    <div className="col-sm-12 text-end">
                                        <button type="button" id="save-btn" className="btn btn-primary case-action-btn" onClick={saveUser}>Save</button>
                                        <button type="button" id="cancel-btn" className="btn btn-secondary me-0" onClick={this.cancelEdit}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default CreateMappedUser;
